import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home-final-cta-section',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home-final-cta-section.component.html'
})
export class HomeFinalCtaSectionComponent {}
